@use "../../variables" as *;
@use "../../mixins" as *;

.interstitial-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1112;
  background: rgba($grey-text, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  .interstitial-container {
    position: relative;
    background: $white;
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    @include tablet {
      max-width: 29rem;
      max-height: 36.5rem;
      height: auto;
      overflow: hidden;
    }

    .close {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      cursor: pointer;
    }

    .back {
      position: absolute;
      top: 1.25rem;
      left: 1.25rem;
      cursor: pointer;

      svg {
        width: 1rem;
        height: 1.125rem;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      padding: 2rem;
      align-items: center;

      @include mobile {
        display: flex;
        justify-content: center;
        height: 100%;
        padding: 0 1.25rem;
      }

      .logo-container {
        img {
          width: auto;
          height: 100%;
        }
      }

      .text-container {
        width: 100%;
        text-align: center;
        font-size: 1rem;
        line-height: 1.25rem;
        display: flex;
        justify-content: center;

        .info {
          padding: 1rem 0 2rem 0;
        }

        .error {
          padding: 1rem 0 2rem 0;

          & .exclamation-point {
            margin-bottom: 0.5rem;
          }

          & .error-message {
            color: $blue-info;
          }
        }
      }

      .stay-logged-reset-password-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .product-client-checkbox {
          cursor: pointer;
          display: none;
        }

        .product-client-checkbox-label {
          text-transform: none;
          background-color: transparent;
          letter-spacing: normal;
          font-size: .875rem;
          color: $grey-text-light;
          font-weight: 300;
          padding: 0;

          &:hover {
            color: $grey;
            cursor: pointer;
          }
        }
      }

      input[type="checkbox"] {
        width: 0;
        height: 0;
        margin: 0;
      }

      input[type="checkbox"] + label {
        position: relative;
        overflow: hidden;
        cursor: pointer;
      }

      input[type="checkbox"] + label::before {
        content: "";
        display: inline-flex;
        background-color: white;
        border: 1px solid $grey-text-light;
        border-radius: 0.125rem;
        margin-right: 0.5625em;
        height: .8125rem;
        width: .8125rem;
      }

      input[type="checkbox"]:checked + label::after {
        content: "";
        position: absolute;
        width: 0.5625rem;
        height: 0.25rem;
        background: rgba(85,85,85,0);
        top: 0.25rem;
        left: 0.125rem;
        border: 0.125rem solid $grey;
        border-top: none;
        border-right: none;
        transform: rotate(-45deg);
      }

      .login-inputs {
        width: 100%;

        Input:first-child {
          margin-bottom: 0.5rem;
        }
      }

      .error {
        margin-bottom: .5rem;
        display: flex;
        align-items: center;
        padding-left: 5px;

        .error-info {
          font-size: .8rem;
          line-height: .75rem;
          font-weight: 300;
          width: auto;
          color: $blue-info;
        }

        .error-icon {
          width: 0.875rem;
          height: 0.875rem;
          fill: $blue-info;
          margin-right: 0.25rem;
        }
      }

      .login-buttons {
        display: flex;
        flex-direction: row;
        margin-top: 2rem;
        width: 100%;
        align-items: center;
        justify-content: flex-end;

        button:first-child {
          font-size: 1rem;
        }
      }
    }
  }
}